// extracted by mini-css-extract-plugin
export default {"datagrid":"PermissionTable_datagrid__r5IZg","datagrid-header":"PermissionTable_datagrid-header__LfOXT"};